
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import IconFilter from "@/components/common/icon/IconFilter.vue";
import Multiselect from "vue-multiselect";
import { Getter } from "vuex-class";
import { ICountry, IUserDetailData } from "@/entities";
import {
  IImportsFilterParams,
  ILabelValue,
  ImportStatusEnum,
  ImportTypeEnum,
  IPageResponse,
} from "@/services";

@Component({
  name: "imports-filter",
  components: { IconFilter, Multiselect },
})
export default class ImportsFilter extends Vue {
  @Getter("getLoggedUser") getLoggedUser!: IUserDetailData;
  @Getter("getCountriesPage") countriesPage!: IPageResponse<ICountry>;
  @Getter("getLocale") locale!: string;

  @Prop({ required: true }) params!: IImportsFilterParams;

  paramsEdit: IImportsFilterParams = {};
  visible = false;

  created(): void {
    this.paramsEdit = { ...this.params };
  }

  statusOptions: ILabelValue<ImportStatusEnum>[] = [
    { label: this.$t("label.import.status.pending"), value: ImportStatusEnum.PENDING },
    {
      label: this.$t("label.import.status.in_progress"),
      value: ImportStatusEnum.IN_PROGRESS,
    },
    {
      label: this.$t("label.import.status.uploaded"),
      value: ImportStatusEnum.UPLOADED,
    },
  ];

  importTypeOptions: ILabelValue<ImportTypeEnum>[] = [
    {
      label: this.$t("label.import.type.servicepoint"),
      value: ImportTypeEnum.SERVICE_POINT,
    },
  ];

  @Watch("params", { deep: true })
  onParamsChange(newParams: IImportsFilterParams): void {
    this.paramsEdit = { ...newParams };
  }

  doFilter(): void {
    this.$emit("update:params", { ...this.paramsEdit });
    this.visible = false;
    this.$emit("filter");
  }

  doCleanUp(): void {
    this.paramsEdit = {
      countries: undefined,
      userTypes: undefined,
      usernameOrIdPrecise: false,
      usernameOrId: "",
      importTypes: undefined,
      statuses: undefined,
      requestedAt: undefined,
    };
    this.$emit("update:params", { ...this.paramsEdit });
    this.visible = false;
    this.$emit("filter");
  }

  get countryOptions(): ICountry[] {
    return this.countriesPage?.content || [];
  }

  get countriesSelected(): ICountry[] {
    return (
      this.countryOptions.filter((opt) => this.paramsEdit.countries?.includes(opt.code!)) || []
    );
  }

  set countriesSelected(selected: ICountry[]) {
    this.paramsEdit.countries = selected.map((opt) => opt.code!);
  }

  get statusSelected(): ILabelValue<ImportStatusEnum>[] {
    return this.statusOptions.filter((opt) => this.paramsEdit.statuses?.includes(opt.value)) || [];
  }

  set statusSelected(selected: ILabelValue<ImportStatusEnum>[]) {
    this.paramsEdit.statuses = selected.map((opt) => opt.value);
  }

  get importsSelected(): ILabelValue<ImportTypeEnum>[] {
    return (
      this.importTypeOptions.filter((opt) => this.paramsEdit.importTypes?.includes(opt.value)) || []
    );
  }

  set importsSelected(selected: ILabelValue<ImportTypeEnum>[]) {
    this.paramsEdit.importTypes = selected.map((opt) => opt.value);
  }

  get requestedDateImport(): string | undefined {
    return this.paramsEdit.requestedAt;
  }

  set requestedDateImport(value: string | undefined) {
    this.paramsEdit.requestedAt = value;
  }

  get filterLength(): number {
    let length = 0;
    if (this.paramsEdit.countries?.length) length++;
    if (this.paramsEdit.statuses?.length) length++;
    if (this.paramsEdit.userTypes?.length) length++;
    if (this.paramsEdit.usernameOrId?.length) length++;
    if (this.paramsEdit.importTypes?.length) length++;
    if (this.paramsEdit.requestedAt) length++;
    return length;
  }

  get isAdmin(): boolean {
    return this.getLoggedUser?.admin || false;
  }

  get typeUserSelected(): ILabelValue<string>[] {
    return (
      this.typeUserOptions.filter((opt) => this.paramsEdit.userTypes?.includes(opt.value)) || []
    );
  }

  set typeUserSelected(selected: ILabelValue<string>[]) {
    this.paramsEdit.userTypes = selected.map((opt) => opt.value);
  }

  get typeUserOptions(): ILabelValue<string>[] {
    return [
      { label: "CLIENTE" as string, value: "CLIENTE" },
      { label: "PROSEGUR" as string, value: "PROSEGUR" },
    ];
  }
}
